import { useEffect } from 'react';

// Stand-in for the App Router's per-route `export const metadata`. Next emitted
// these into the served HTML; with no server, they can only be applied after
// mount. Good enough for browser tabs, history entries and bookmarks — but note
// that link unfurlers (Slack, iMessage, X) and most non-Google crawlers read the
// raw HTML and will only ever see the defaults in index.html. Restoring real
// per-page metadata means either prerendering or an SSR framework.
export function useDocumentMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;

    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'description';
      document.head.appendChild(tag);
    }
    tag.content = description;
  }, [title, description]);
}
